export default __webpack_public_path__ + "static/media/Ellipse 12 (3).02e13505.png";